/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { ChatConversation } from './ChatConversation';
import {
    ChatConversationFromJSON,
    ChatConversationFromJSONTyped,
    ChatConversationToJSON,
    ChatConversationToJSONTyped,
} from './ChatConversation';

/**
 * 
 * @export
 * @interface ListConversationsResponse
 */
export interface ListConversationsResponse {
    /**
     * 
     * @type {Array<ChatConversation>}
     * @memberof ListConversationsResponse
     */
    conversations: Array<ChatConversation>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListConversationsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListConversationsResponse interface.
 */
export function instanceOfListConversationsResponse(value: object): value is ListConversationsResponse {
    if (!('conversations' in value) || value['conversations'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListConversationsResponseFromJSON(json: any): ListConversationsResponse {
    return ListConversationsResponseFromJSONTyped(json, false);
}

export function ListConversationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListConversationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'conversations': ((json['conversations'] as Array<any>).map(ChatConversationFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

export function ListConversationsResponseToJSON(json: any): ListConversationsResponse {
    return ListConversationsResponseToJSONTyped(json, false);
}

export function ListConversationsResponseToJSONTyped(value?: ListConversationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conversations': ((value['conversations'] as Array<any>).map(ChatConversationToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

